import { render, staticRenderFns } from "./ListStyle1.vue?vue&type=template&id=31e31463&"
import script from "./ListStyle1.vue?vue&type=script&lang=js&"
export * from "./ListStyle1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports